import { ToastType } from "../types/toast";

type AddToastFunction = (message: string, type: ToastType) => void;

/**
 * Глобальный менеджер toast-уведомлений для использования вне React компонентов
 * Используется в API клиентах и других утилитах где недоступны React hooks
 */
class ToastManager {
  private addToastFn: AddToastFunction | null = null;

  /**
   * Регистрирует функцию добавления toast из React контекста
   * Вызывается из ToastProvider при инициализации
   */
  register(addToast: AddToastFunction): void {
    this.addToastFn = addToast;
  }

  /**
   * Отменяет регистрацию функции (cleanup)
   */
  unregister(): void {
    this.addToastFn = null;
  }

  /**
   * Показывает toast уведомление
   * Безопасно работает даже если ToastProvider еще не инициализирован
   */
  show(message: string, type: ToastType): void {
    if (this.addToastFn) {
      this.addToastFn(message, type);
    } else {
      // Fallback - логируем в консоль если toast еще не готов
      console.warn(`[Toast not ready] ${type.toUpperCase()}: ${message}`);
    }
  }

  /**
   * Показывает успешное уведомление
   */
  success(message: string): void {
    this.show(message, ToastType.Success);
  }

  /**
   * Показывает информационное уведомление
   */
  info(message: string): void {
    this.show(message, ToastType.Info);
  }

  /**
   * Показывает предупреждение
   */
  warning(message: string): void {
    this.show(message, ToastType.Warning);
  }

  /**
   * Показывает ошибку
   */
  error(message: string): void {
    this.show(message, ToastType.Error);
  }
}

// Singleton instance
export const toastManager = new ToastManager();
